import { render, staticRenderFns } from "./MuleexLogo.vue?vue&type=template&id=5cf7bb5e&scoped=true"
import script from "./MuleexLogo.vue?vue&type=script&lang=js"
export * from "./MuleexLogo.vue?vue&type=script&lang=js"
import style0 from "./MuleexLogo.vue?vue&type=style&index=0&id=5cf7bb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf7bb5e",
  null
  
)

export default component.exports